import { userDate } from '../owaDate';

export default () => userDate();
